"use strict";
/*jshint esversion: 11 */

import PivotalAttachmentsApi from '../../../js/csf/pivotal/PivotalAttachmentsApi';
import { convertBase64 } from '../../csf-ufc-fournisseur/includes/utils';
import PivotalApiEnvironments from '../../../js/csf/pivotal/PivotalApiEnvironments';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";

export async function handleNotificationUpload({
  selectedFile,
  setIsUploading,
  setIsError,
  attendanceId,
  apiUrl,
  apiEnv,
  accessToken,
  notificationId
}) {
  if (!selectedFile) return;

  setIsUploading(true);
  setIsError(false);

  try {
    const fileBase64 = await convertBase64(selectedFile);

    const requestData = {
      "uploadFileBase64": fileBase64
    };

    const pivotalAttachmentApi = new PivotalAttachmentsApi(apiUrl, apiEnv, accessToken);

    await pivotalAttachmentApi.callTaskUploadEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        // ajout de log pour faciliter la validation de ce qui a été ajouté
        // sur Pivotal
        console.log('Uploaded file ID: ' + response.payload.uploadID);
        const uploadFileId = response.payload.uploadID;

        // Récupérer les infos sur le fichier
        const fileFullName = selectedFile.name;
        const fileSize = selectedFile.size;

        // Extraction de l'extension et du nom sans extension
        const lastDotIndex = fileFullName.lastIndexOf('.');
        let fileExt = '';
        let fileNameNoExt = fileFullName;
        if (lastDotIndex > 0) {
          fileExt = fileFullName.substring(lastDotIndex + 1);
          fileNameNoExt = fileFullName.substring(0, lastDotIndex);
        }

        const lastModifiedDateTime = new Date(selectedFile.lastModifiedDate);
        const lastModifiedDate = `${lastModifiedDateTime.getMonth() + 1}/${lastModifiedDateTime.getDate()}/${lastModifiedDateTime.getFullYear()}`;
        const lastModifiedTime = `${lastModifiedDateTime.getHours()}:${lastModifiedDateTime.getMinutes()}:${lastModifiedDateTime.getSeconds()}`;

        // Appel à 5.3 Soumission d’une attestation à travers une notification
        const notificationUpdateData = {
          'form': 'CSF_EM_Attachment_Notif_REST',
          'recordId': attendanceId,
          'deltaData': {
            'EM_Attestation': fileFullName,
            'EM_Attestation_UploadID': uploadFileId,
            'RN_EM_Attestation_ED': lastModifiedDate,
            'RN_EM_Attestation_ET': lastModifiedTime,
            'RN_EM_Attestation_EX': fileExt,
            'RN_EM_Attestation_FN': fileNameNoExt,
            'RN_EM_Attestation_FZ': fileSize,
            'Notification_Id': notificationId,
          }
        };

        const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
        pivotalFormApi.callFormPutEndpoint(notificationUpdateData, PivotalApiEnvironments.getEspaceMembreSuffix())
          .then(response => {
            if (response?.success && response?.payload != null) {
              window.location.reload();
            } else {
              setIsError(true);
            }
          })
          .catch(error => {
            setIsError(true);
            setIsUploading(false);
          });

      })
      .catch(error => {
        setIsError(true);
        console.error('Error during file upload:', error);
      });

  } catch (error) {
    setIsError(true);
    setIsUploading(false);
    console.error('Error during file upload:', error);
  }
}
